"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPhone = void 0;
var React = __importStar(require("react"));
var IconPhone = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20.85,18.4987 C20.219,19.4037 18.771,20.9507 18.342,20.9987 C15.267,20.8997 11.495,17.7507 8.871,15.1267 C6.247,12.5027 3.099,8.7277 2.999,5.6507 C3.047,5.2277 4.594,3.7787 5.5,3.1447 C5.661,3.0327 5.804,2.9987 5.912,2.9987 C6.026,2.9987 6.102,3.0357 6.123,3.0597 C6.334,3.3517 8.541,6.6967 8.772,7.0607 C8.798,7.1027 8.816,7.3347 8.635,7.6777 C8.417,8.0947 7.507,9.6837 7.506,9.6847 C7.417,9.8397 7.418,10.0307 7.509,10.1857 C7.537,10.2327 8.214,11.3687 10.421,13.5757 C12.629,15.7827 13.765,16.4607 13.812,16.4887 C13.966,16.5787 14.157,16.5787 14.314,16.4907 C14.314,16.4907 15.904,15.5807 16.321,15.3607 C16.638,15.1947 16.881,15.1927 16.941,15.2297 C17.325,15.4647 20.681,17.6967 20.941,17.8787 C20.987,17.9167 21.081,18.1697 20.85,18.4987 M21.516,17.0607 C21.276,16.8937 17.893,14.6407 17.464,14.3767 C17.049,14.1247 16.448,14.1617 15.854,14.4777 C15.539,14.6437 14.563,15.1977 14.086,15.4707 C13.663,15.1717 12.669,14.4097 11.128,12.8687 C9.588,11.3287 8.826,10.3347 8.528,9.9117 C8.8,9.4347 9.355,8.4577 9.52,8.1437 C9.839,7.5387 9.875,6.9347 9.617,6.5257 C9.372,6.1417 7.16,2.7867 6.933,2.4737 C6.576,1.9787 5.707,1.7827 4.927,2.3247 C4.897,2.3467 1.962,4.4557 2,5.6857 C2.11,9.0877 5.412,13.0817 8.164,15.8337 C10.915,18.5857 14.909,21.8897 18.324,21.9987 L18.347,21.9987 C19.551,21.9987 21.65,19.1007 21.669,19.0717 C22.222,18.2837 22.021,17.4147 21.516,17.0607" }))); };
exports.IconPhone = IconPhone;
exports.IconPhone.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconPhone;
